import { IStyle } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontWeights, Sizes } from '../../themes/styles';
import { CommonStyles } from '../../themes/themes';

export interface IAccordionStyles {
  root: IStyle;
  content: IStyle;
  header: IStyle;
  headerContent: IStyle;
  icon: IStyle;
  title: IStyle;
  subTitle: IStyle;
  body: IStyle;
}
const headerHeight = 48;
const padding = 24;

export const accordionStylesDefault = (theme: IH2OTheme): IAccordionStyles => ({
  root: {
    position: 'relative',
    border: `1px solid ${theme.palette?.gray300}`,
    borderRadius: Sizes.borderRadius,
    transition: 'height .3s ease-in-out',
    overflow: 'hidden',
    '&.is-close': {
      height: `${headerHeight}px !important`,
      '.h2o-Accordion-icon': {
        transform: 'rotate(0deg)',
      },
    },
  },
  content: {
    position: 'relative',
    padding: `0 ${padding}px ${padding}px ${padding}px`,
  },
  header: {
    position: 'relative',
    cursor: 'pointer',
    lineHeight: headerHeight,
    paddingRight: 20,
    ...CommonStyles.truncateString,
  },
  icon: {
    position: 'absolute',
    right: 0,
    transition: 'transform .3s ease-in-out',
    transform: 'rotate(90deg)',
  },
  headerContent: {
    display: 'flex',
    overflow: 'hidden',
    width: '100%',
  },
  title: {
    fontWeight: FontWeights.semiBold,
    color: theme.semanticColors?.textQuaternary,
  },
  subTitle: {
    color: theme.semanticColors?.textSecondary,
    paddingLeft: 4,
  },
  body: {},
});
